import type { EcommerceApc } from '../types/newProductCard.type';
import { availabilityDictionaryByStatus } from '../../../../../../utils/middleware-pipe/pipes/e-commerce/e-commerce-status-dictionary';
import type {UcItem} from '../../../utils/ucOptions';
import type {SearchProduct} from '../../../../../../components';

export const getEcommerceData = (
  id: string,
  productIds: EcommerceApc['availibilityInfo'],
  eShopUrl: string
): EcommerceApc => {
    const availibilityInfo = productIds.filter((p) => p.id === id);
    const viewConfiguration =
    availabilityDictionaryByStatus[availibilityInfo[0]?.availabilityStatus];

    return {
      price: availibilityInfo[0]?.price,
      availibilityInfo,
      viewConfiguration,
      eShopUrl,
    };
};

export const getRangesCombinedTerm = (ranges, category, allowRangeCategory = false): string => {
    if (ranges !== undefined && (category === 'Product' || (allowRangeCategory && category === 'Product Range'))) {
      const rangesArray = ranges instanceof Array ? ranges : [ranges];

      if (rangesArray?.some((obj) => 'key' in obj)) {
        return rangesArray
          ?.map((item) => item.key)
          .join(' ')
          .trim();
      }

      return '';
    }

    return '';
};

export enum ResultCardType {//eslint-disable-line @stencil-community/ban-exported-const-enums
  Product = 'Product',
  ProductAPC = 'ProductAPC',
  Basic = 'Basic',
  Document = 'Document',
  Dropdown = 'dropdown-cta'
}

export const getWcEventData = (eventName: string, country: string, language: string, id: string) => {
    return {
      'type': 'easy',
      'payload': {
        'data': {
          'event': eventName,
          'source': 'SE SRP'
        },
        'bom': {
          'country': country.toUpperCase(),
          'locale': `${language}-${country?.toUpperCase()}`,
          'products': [
            {
              'partType': 'nonCto',
              'productId': id,
              'quantity': 1,
              'applicationSource': 'Search',
              'subparts': []
            }
          ]
        }
      }
    };
};

export const getGAEventData = (eventName: string, items: Array<UcItem>, location: string, currency?: string, value?: string ) => {
    return {
      eventName: eventName,
      currency: currency,
      value: value,
      location: location,
      items: items
    };
};